import axios, { type AxiosRequestConfig } from 'axios'
import { attachAuthInterceptors } from './authBridge'
import { ApiError, type ApiEnvelope } from './envelope'

export function createHttpClient(baseURL: string) {
  const client = axios.create({ baseURL, timeout: 20_000, headers: { 'Content-Type': 'application/json' } })
  attachAuthInterceptors(client)

  async function request<T>(config: AxiosRequestConfig): Promise<{ data: T; pagination?: ApiEnvelope<T>['pagination'] }> {
    try {
      const response = await client.request<ApiEnvelope<T>>(config)
      if (!response.data.success) throw new ApiError(response.status, response.data.message, response.data.messageCode)
      return { data: response.data.data as T, pagination: response.data.pagination }
    } catch (cause) {
      if (cause instanceof ApiError) throw cause
      if (axios.isAxiosError<ApiEnvelope<unknown>>(cause)) {
        const body = cause.response?.data
        throw new ApiError(cause.response?.status ?? 0, body?.message || 'Không thể kết nối máy chủ.', body?.messageCode)
      }
      throw cause
    }
  }

  return { request }
}
